/* eslint-disable @next/next/no-img-element */
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import NextImage from 'next/image'

import { Text } from '~/ui'

import { TeamText } from '../../ui/team-text'
import { Consultation } from '../ourDifference/bookconsultation'

export function TeamCard(props) {
  const { data } = props

  return (
    <div className="h-full w-full max-w-[440px] justify-self-center">
      <div className="my-[-80px] ml-[30px]">
        <NextImage
          src={data.node.featuredImage?.node.sourceUrl ?? '/assets/images/avatar-placeholder.png'}
          alt="Team Member"
          width={219}
          height={188}
          className="h-[150px] w-[150px] rounded-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="w-full rounded-lg bg-colorFifteen/10 p-[30px] pb-4 text-colorFifteen">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="hidden sm:flex w-full  flex-col items-end justify-between rounded-lg pl-[160px] text-left text-sm font-medium">
                <p className="text-right text-lg font-bold">{data.node.title}</p>
                <Text className="text-right">{data.node.Team.memberRegion}</Text>
                <ChevronDownIcon
                  className={`${open ? 'rotate-180' : ''} h-8 w-8 text-colorFifteen`}
                />
              </Disclosure.Button>
              <Disclosure.Button className="mt-[70px] sm:hidden  w-full rounded-lg   text-sm font-medium">
                <div>
                    <div className='flex w-full justify-between'>
                        <p className="text-right text-md xs:text-lg font-bold">{data.node.title}</p>
                        <ChevronDownIcon
                          className={`${open ? 'rotate-180' : ''} h-8 w-8 text-colorFifteen`}
                          />
                    </div>
                </div>
                <Text  className="xs:text-sm  text-xs text-left">{data.node.Team.memberRegion}</Text>
              </Disclosure.Button>
              <Disclosure.Panel className="py-2 text-base text-colorFifteen">
                <div
                  className="prose text-inherit"
                  dangerouslySetInnerHTML={{
                    __html: data.node.Team.bio
                  }}
                />
                <div className="flex items-center gap-5 pt-5">
                  <a href={data.node.Team.memberFacebook} target="_blank" rel="noopener noreferrer">
                    <NextImage
                      src="/assets/social/facebook.svg"
                      alt="Facebook"
                      height={24}
                      width={24}
                      loading="lazy"
                    />
                  </a>
                  <p>{data.node.Team.memberPhone}</p>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  )
}
